// Polyfill localStorage for non-browser environments (e.g., during SSR or build)
// This prevents "Cannot initialize local storage" errors in Node.js environments

// Mock localStorage in global scope for webpack build
if (typeof global !== 'undefined' && typeof global.localStorage === 'undefined') {
  const storage = new Map<string, string>();

  const localStoragePolyfill = {
    getItem(key: string): string | null {
      return storage.get(key) || null;
    },
    setItem(key: string, value: string): void {
      storage.set(key, value);
    },
    removeItem(key: string): void {
      storage.delete(key);
    },
    clear(): void {
      storage.clear();
    },
    key(index: number): string | null {
      const keys = Array.from(storage.keys());
      return keys[index] || null;
    },
    get length(): number {
      return storage.size;
    },
  };

  Object.defineProperty(global, 'localStorage', {
    value: localStoragePolyfill,
    writable: true,
    configurable: true,
  });
}

// Also define on window if it exists but localStorage doesn't
if (typeof window !== 'undefined' && typeof window.localStorage === 'undefined') {
  const storage = new Map<string, string>();

  const localStoragePolyfill = {
    getItem(key: string): string | null {
      return storage.get(key) || null;
    },
    setItem(key: string, value: string): void {
      storage.set(key, value);
    },
    removeItem(key: string): void {
      storage.delete(key);
    },
    clear(): void {
      storage.clear();
    },
    key(index: number): string | null {
      const keys = Array.from(storage.keys());
      return keys[index] || null;
    },
    get length(): number {
      return storage.size;
    },
  };

  Object.defineProperty(window, 'localStorage', {
    value: localStoragePolyfill,
    writable: true,
    configurable: true,
  });
}

export {};
